import usePublishRoles from "api/CommandCenterResource/usePublishRoles";
import { AiOutlineLoading3Quarters, AiOutlineRight } from "react-icons/ai";

const PublishRoles = () => {
	const { mutateAsync, isLoading } = usePublishRoles();

	const publishRoles = async () => {
		await mutateAsync();
	};

	return (
		<div className="w-full px-2 py-2 rounded-lg bg-akgreen border-2 border-akgreener flex justify-between items-center text-white">
			<span className="text-base">Publish roles</span>
			<button
				type="button"
				onClick={publishRoles}
				className="flex justify-between items-center px-2 py-2 bg-akgreenest rounded-lg gap-2"
			>
				Run
				{isLoading ? (
					<AiOutlineLoading3Quarters
						size={20}
						className="animate-spin"
					/>
				) : (
					<AiOutlineRight size={20} />
				)}
			</button>
		</div>
	);
};

export default PublishRoles;
